import { boolean } from "yup";


export interface InvoiceFilterFieldsPayload{
  ready: "ready" | "to_review" | null,
  tax: "with_tax" | "without_tax" | null,
  taxRate: "with_tax_rate" | "without_tax_rate" | null,
  category: "with_category" | "without_category" | null,
  currency: "default_currency" | "foreign_currency" | null,
  read: "read" | "unread" | null,
  flag: "flagged" | "unflagged" | null,
  note: "with_note" | "without_note" | null,
  merged: "merged" | "not_merged" | null,
  duplicates: "with_duplicates" | "without_duplicates" | null,
  paid: "paid" | "unpaid" | null,
  hasMatch: "match" | "non_match" | null,
  autoCategorised: "auto" | "manual" | null,
  expenseClaim: "added" | "not_added" | null,
  dataExtraction: "with_extraction_warnings" | "without_extraction_warnings" | null
}; 
export const InvoiceFilterFields = [
  {
    key: "ready",
    label: "Ready",
    hidden: false,
    disabled: false,
    options: [
      { label: "Ready", value: "ready" },
      { label: "To review", value: "to_review" }
    ]
  },
  {
    key: "tax",
    label: "Tax",
    hidden: false,
    disabled: false,
    options: [
      { label: "With tax", value: "with_tax" },
      { label: "Without tax", value: "without_tax" }
    ]
  },
  {
    key: "taxRate",
    label: "Tax rate",
    hidden: false,
    disabled: true,
    options: [
      { label: "With tax rate", value: "with_tax_rate" },
      { label: "Without tax rate", value: "without_tax_rate" }
    ]
  },
  {
    key: "category",
    label: "Category",
    hidden: false,
    disabled: false,
    options: [
      { label: "With category", value: "with_category" },
      { label: "Without category", value: "without_category" }
    ]
  },
  {
    key: "currency",
    label: "Currency",
    hidden: false,
    disabled: false,
    options: [
      { label: "Default currency", value: "default_currency" },
      { label: "Foreign currency", value: "foreign_currency" }
    ]
  },
  {
    key: "read",
    label: "Read",
    hidden: false,
    disabled: false,
    options: [
      { label: "Read", value: "read" },
      { label: "Unread", value: "unread" }
    ]
  },
  {
    key: "flag",
    label: "Flag",
    hidden: false,
    disabled: false,
    options: [
      { label: "Flagged", value: "flag" },
      { label: "Unflagged", value: "unflag" }
    ]
  },
  {
    key: "note",
    label: "Note",
    hidden: false,
    disabled: false,
    options: [
      { label: "With note", value: "with_note" },
      { label: "Without note", value: "without_note" }
    ]
  },
  {
    key: "merged",
    label: "Merged",
    hidden: false,
    disabled: false,
    options: [
      { label: "Merged", value: "merged" },
      { label: "Not merged", value: "not_merged" }
    ]
  },
  {
    key: "duplicates",
    label: "Duplicates",
    hidden: false,
    disabled: false,
    options: [
      { label: "With duplicates", value: "with_duplicates" },
      { label: "Without duplicates", value: "without_duplicates" }
    ]
  },
  {
    key: "paid",
    label: "Paid",
    hidden: false,
    disabled: false,
    options: [
      { label: "Paid", value: "paid" },
      { label: "Unpaid", value: "unpaid" }
    ]
  },
  {
    key: "hasMatch",
    label: "Has match",
    hidden: false,
    disabled: true,
    options: [
      { label: "Match", value: "match" },
      { label: "Non-match", value: "non_match" }
    ]
  },
  {
    key: "autoCategorised",
    label: "Auto-categorised",
    hidden: false,
    disabled: true,
    options: [
      { label: "Auto-categorised", value: "auto" },
      { label: "Manually categorised", value: "manual" }
    ]
  },
  {
    key: "expenseClaim",
    label: "Expense Claim",
     hidden: false,
    disabled: true,
    options: [
      { label: "Added to expense claim", value: "added" },
      { label: "Not added to expense claim", value: "not_added" }
    ]
  },
  {
    key: "dataExtraction",
    label: "Data extraction",
    hidden: false,
    disabled: true,
    options: [
      { label: "with extraction warnings", value: "with_extraction_warnings" },
      { label: "Without extraction warnings", value: "without_extraction_warnings" }
    ]
  }
];



